import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";

import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getSingleWork, updateWork } from "store/works/actions";
import Loader from "components/shared/Loader";
import { EditorComponent } from "components/shared/FormComponents";
import ImagesUpload from "components/shared/ImagesUploader";
import { getCategories } from "store/actions";

const EditSocial = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const { singleWork, loading } = useSelector((state) => state?.works);
  const { categories } = useSelector((state) => state?.categories);

  const [description, setDescription] = useState("");
  const [images, setImages] = useState([]);

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    dispatch(getSingleWork({ id }));
  }, [dispatch, id]);

  useEffect(() => {
    reset({
      title: singleWork?.title,
      category: singleWork?.category?._id,
    });

    setImages(singleWork?.image);

    setDescription(singleWork?.description);
  }, [singleWork, reset]);

  const onSubmit = (data) => {
    data.description = description;
    data.image = images;

    dispatch(
      updateWork({
        id,
        data,
        navigate,
        toast,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>تعديل البيانات</h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Col xl={10} md={12}>
                <Row>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>صور العمل </h5>
                      <div>
                        <ImagesUpload
                          imagesURLs={images}
                          setImageURLs={setImages}
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>اسم العمل </h5>
                      <div>
                        <input
                          type="text"
                          className="form-control form-outline"
                          placeholder="اسم العمل "
                          {...register("title", { required: true })}
                        />
                      </div>
                      <p className="error-hint">
                        {errors?.title && "يرجي ادخال اسم العمل "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={6} xs={12}>
                    <div className="form-group required">
                      <h5>تصنيف العمل </h5>
                      <div>
                        <select
                          className="form-control form-outline form-select"
                          {...register("category", { required: true })}
                        >
                          <option value="">اختر تصنيف العمل</option>
                          {categories?.map((category, index) => (
                            <option value={category._id} key={index}>
                              {category.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <p className="error-hint">
                        {errors?.category && "يرجي ادخال اسم العمل "}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12} xs={12}>
                    <div className="form-group required">
                      <h5>وصف</h5>
                      <div>
                        <EditorComponent
                          name="description"
                          setData={setDescription}
                          initialValue={description}
                        />
                      </div>
                      <p className="error-hint">
                        {description === "" && "يرجي ادخال وصف العمل"}
                      </p>
                    </div>
                  </Col>
                  <Col lg={4} xs={12}>
                    <div className="form-group">
                      <button type="submit" className="btn btn-blue">
                        اضافة
                      </button>
                    </div>
                  </Col>
                </Row>
              </Col>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSocial;
